// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createMenuSearchInput {
  width: 100%;
  border: none;
  background-color: #f5f5f5 !important;
  padding: 10px 10px 10px 35px;
  color: var(--surface-black);
  border-radius: 0.5rem;
}

.createMenuSearchInputContainer {
  position: relative;
  width: 100%;
}

.createMenuSearchInputContainer > *:first-child {
  position: absolute;
  top: 50%;
  left: 0.5rem;
  transform: translateY(-50%);
  pointer-events: none;
}

/* ── Dark mode ── */
.dark .createMenuSearchInput {
  background-color: #1e293b !important;
  color: #f1f5f9;
  border-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/CreateMenu/CreateMenuSearchbar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".createMenuSearchInput {\n  width: 100%;\n  border: none;\n  background-color: #f5f5f5 !important;\n  padding: 10px 10px 10px 35px;\n  color: var(--surface-black);\n  border-radius: 0.5rem;\n}\n\n.createMenuSearchInputContainer {\n  position: relative;\n  width: 100%;\n}\n\n.createMenuSearchInputContainer > *:first-child {\n  position: absolute;\n  top: 50%;\n  left: 0.5rem;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n/* ── Dark mode ── */\n.dark .createMenuSearchInput {\n  background-color: #1e293b !important;\n  color: #f1f5f9;\n  border-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
